// removed by extract-text-webpack-plugin
module.exports = {"Navigation":"src-components-WhatAboutCollege-DINavigation----DINavigation-module---Navigation---2OhaS","sidebar__donate":"src-components-WhatAboutCollege-DINavigation----DINavigation-module---sidebar__donate---3o8gL","Navigation__wrapper":"src-components-WhatAboutCollege-DINavigation----DINavigation-module---Navigation__wrapper---zd35f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WhatAboutCollege/DINavigation/DINavigation.module.scss
// module id = 748
// module chunks = 168707334958949